import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { parseFnaimServices } from '../../../../utils/companyDetails';
import type { CompanyInfoBlockProps } from './types';

const ServicePill = ({ children }: { children: React.ReactNode }) => (
  <span className="rounded-full bg-blue-100 px-3 py-1 text-sm text-blue-800">{children}</span>
);

/** Activities known by DJ, then the services listed in the FNAIM and SNPI directories. */
export default function CompanyServicesBlock({ details, loading }: CompanyInfoBlockProps) {
  return (
    <div className="mb-4 rounded-lg bg-gray-50 p-4">
      <h3 className="text-md mb-2 font-semibold">Services (DJ)</h3>
      {loading ? (
        <>
          <div className="mb-4 grid grid-cols-2 gap-2 md:grid-cols-4">
            <Skeleton width={100} height={28} className="rounded-full" />
            <Skeleton width={100} height={28} className="rounded-full" />
            <Skeleton width={100} height={28} className="rounded-full" />
            <Skeleton width={100} height={28} className="rounded-full" />
          </div>
          <div className="mt-4">
            <h4 className="mb-2 text-sm font-semibold">Services FNAIM</h4>
            <div className="mb-4 grid grid-cols-2 gap-2 md:grid-cols-4">
              <Skeleton width={150} height={28} className="rounded-full" />
              <Skeleton width={130} height={28} className="rounded-full" />
              <Skeleton width={140} height={28} className="rounded-full" />
            </div>
          </div>
          <div className="mt-4">
            <h4 className="mb-2 text-sm font-semibold">Services SNPI</h4>
            <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
              <Skeleton width={150} height={28} className="rounded-full" />
              <Skeleton width={130} height={28} className="rounded-full" />
              <Skeleton width={140} height={28} className="rounded-full" />
            </div>
          </div>
        </>
      ) : (
        <>
          {details?.syndic || details?.gesLoc || details?.transa || details?.loc ? (
            <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
              {details?.syndic && <ServicePill>Syndic</ServicePill>}
              {details?.gesLoc && <ServicePill>Gestion locative</ServicePill>}
              {details?.transa && <ServicePill>Transaction</ServicePill>}
              {details?.loc && <ServicePill>Location</ServicePill>}
            </div>
          ) : (
            <p className="text-sm text-gray-600">Aucune activité renseignée par DJ.</p>
          )}
          {details?.fnaimServices && (
            <div className="mt-4">
              <h4 className="mb-2 text-sm font-semibold">Services FNAIM</h4>
              <div className="mb-4 grid grid-cols-2 gap-2 md:grid-cols-4">
                {parseFnaimServices(details.fnaimServices).map((service) => (
                  <span
                    key={service}
                    className="rounded-full bg-yellow-300 px-3 py-1 text-sm text-black"
                  >
                    {service}
                  </span>
                ))}
              </div>
            </div>
          )}
          {(details?.snpiAdministrator
            || details?.snpiManager
            || details?.snpiHouseAgent
            || details?.snpiExpert) && (
            <div className="mt-4">
              <h4 className="mb-2 text-sm font-semibold">Services SNPI</h4>
              <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
                {details?.snpiManager && <ServicePill>Syndic</ServicePill>}
                {details?.snpiAdministrator && <ServicePill>Administrateur de biens</ServicePill>}
                {details?.snpiHouseAgent && <ServicePill>Agent immobilier</ServicePill>}
                {details?.snpiExpert && <ServicePill>Expert immobilier</ServicePill>}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
